import React from 'react';
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { NewsletterPreview } from "@/components/preview/NewsletterPreview";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface TemplateContentProps {
  content: string;
  onChange: (content: string) => void;
}

export const TemplateContent = ({ content, onChange }: TemplateContentProps) => {
  return (
    <Tabs defaultValue="edit" className="w-full">
      <TabsList>
        <TabsTrigger value="edit">Edit</TabsTrigger>
        <TabsTrigger value="preview">Preview</TabsTrigger>
      </TabsList>

      <TabsContent value="edit" className="space-y-4">
        <Label htmlFor="content">Content Template</Label>
        <Textarea
          id="content"
          value={content}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter your template content here..."
          rows={15}
          className="font-mono"
        />
      </TabsContent>

      <TabsContent value="preview">
        <NewsletterPreview content={content} />
      </TabsContent>
    </Tabs>
  );
};